@if (!categoryStore.asArray().length) {
  <app-alert header="Keine Indikatoren-Bereiche vorhanden" [canToggle]="false">
    Legen Sie zuerst Indikatoren-Bereiche über das
    <a
      [routerLink]="[
        '/data-backend',
        {
          outlets: {
            overlay: [
              'neu',
              { outlets: { panel: ['indikatoren-bereich', 'neu'] } },
            ],
          },
        },
      ]"
      >Formular</a
    >
    an.
  </app-alert>
  <p-divider />
}
<div class="grid">
  <div
    [ngClass]="{
      'col-6': !indicatorsToImport.length,
      'col-12': indicatorsToImport.length,
    }">
    <app-header
      icon="fas fa-cloud-upload"
      text="Import"
      sub="Laden Sie Ihre Indikatoren aus der Excel-Datei hoch."></app-header>
    @if (canImport()) {
      <div *ngIf="!indicatorsToImport.length" class="flex">
        <p-fileUpload
          mode="basic"
          chooseLabel="Datei hochladen"
          chooseIcon="pi pi-upload"
          name="uploadFile"
          [url]="indicatorService.getImportUrl()"
          [auto]="true"
          accept=".xlsx"
          maxFileSize="1000000"
          (onUpload)="onUpload($event)" />

        <app-download-template
          class="ml-auto"
          type="indicators"></app-download-template>
      </div>
      <p-divider></p-divider>

      <div
        class="px-3 py-1"
        appAlertStyle="info"
        *ngIf="!indicatorsToImport.length">
        <h4 class="flex gap-2 align-items-center">
          <i class="fas fa-circle-info"></i> Indikatoren importieren
        </h4>
        <p>Die Datei muss einem bestimmten Schema entsprechen.</p>
        <p>
          Laden Sie die passende <b>Vorlage</b> herunter, um das richtige Format
          zu verwenden.
        </p>
        @if (activeUserStore.isPortalAdmin()) {
          <p-divider></p-divider>
          <p>
            <p-checkbox
              [disabled]="!indicatorStore.pool"
              [binary]="true"
              [(ngModel)]="importAsPool"></p-checkbox>
            Pool-Import (Admin-Funktion)
          </p>
        }
      </div>
    } @else {
      <app-alert
        header="Fehlende Rechte für den Indikatorenimport"
        [canToggle]="false">
        <p>
          Falls Sie Rechte benötigen um Indikatoren zu importieren, wenden Sie
          sich bitte an den Administrator.
        </p>
      </app-alert>
    }

    <ng-container *ngIf="indicatorsToImport.length">
      <h3>Zusammenfassung</h3>
      <p>
        In der Excel-Datei wurden {{ indicatorsToImport.length }} Indikatoren
        gefunden
      </p>
      <div class="grid">
        <div class="col-6" *ngFor="let severity of validationPreviewSeverities">
          <app-import-preview-box
            [key]="severity"
            [numberOfEntities]="getCountByKey(severity)"
            (itemsToShow)="setItemsToShow($event)"></app-import-preview-box>
        </div>
      </div>

      <div
        class="p-3 pt-1"
        [appAlertStyle]="getCountByKey('error') > 0 ? 'error' : 'info'">
        @if (getCountByKey('error') > 0) {
          <p>
            Der Import kann erst durchgeführt werden, wenn alle Fehler behoben
            wurden.
          </p>
          <p>
            Überprüfen Sie die Details und korrigieren Sie die Fehler in der
            Excel-Datei.
          </p>
          <p>
            <a
              class="underline cursor-pointer"
              (click)="setItemsToShow('error')"
              >Fehlerdetails ansehen.</a
            >
          </p>
        } @else {
          <h4 class="flex gap-2 align-items-center">
            <i class="fas fa-info-circle"></i> Die Excel-Datei wurde erfolgreich
            geprüft!
          </h4>
          <p *ngIf="getCountByKey('warning') > 0">
            Warnungen verhindern den Import <b>nicht</b>. Sie entstehen meist
            durch nicht gefundene Schlagworte, die daher ignoriert werden. Sie
            können diese später oder noch vor dem Import korrigieren.
          </p>
          <p>
            Die neu importierten Indikatoren sind nach dem Import im
            <i>Indikatorenverzeichnis</i> verfügbar. Sie können sie dort
            einsehen und weiter bearbeiten.
          </p>
          <p *ngIf="getCountByKey('info') > 0">
            Indikatoren, die anhand des Indikatorenschlüssels gefunden wurden,
            werden überschrieben.
          </p>
          <p *ngIf="getCountByKey('success') > 0">
            Neue Indikatoren werden automatisch in den entsprechenden Ordner
            platziert.
          </p>
        }

        <p-divider />
        <div class="flex gap-3 align-items-center">
          <p-button
            [rounded]="true"
            severity="secondary"
            icon="fas fa-times-circle"
            [text]="true"
            (onClick)="resetImport()"
            label="abbrechen"></p-button>
          <p-button
            class="ml-auto"
            [rounded]="true"
            [disabled]="getCountByKey('error') > 0"
            icon="fas fa-circle-check"
            (onClick)="importIndicators()"
            label="importieren"></p-button>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!indicatorsToImport.length" class="col-6">
    <app-header
      icon="fas fa-cloud-download"
      text="Export"
      sub="Laden Sie Indikatoren als Excel-Datei herunter.
"></app-header>
    @if (canExport()) {
      <div class="p-3 pt-1" appAlertStyle="info">
        <p>Komplettes Indikatorenverzeichnis exportieren.</p>
        <p-button
          [rounded]="true"
          [disabled]="getCountByKey('error') > 0"
          icon="fas fa-download"
          (onClick)="exportAll()"
          label="alle exportieren"></p-button>
      </div>

      <div class="p-3 pt-1" appAlertStyle="info">
        <p>Ausgewählte Indikatoren exportieren.</p>

        <p-button
          [rounded]="true"
          [disabled]="getCountByKey('error') > 0"
          icon="fas fa-list-check"
          (onClick)="activeExportSelection = true"
          label="Auswahl exportieren"></p-button>
      </div>
    } @else {
      <app-alert
        header="Fehlende Rechte für den Indikatorenexport"
        [canToggle]="false">
        <p>
          Falls Sie Rechte benötigen um Indikatoren zu exportieren, wenden Sie
          sich bitte an den Administrator.
        </p>
      </app-alert>
    }
  </div>
</div>
<p-sidebar
  (onHide)="closeOverview()"
  position="right"
  [modal]="false"
  [styleClass]="'w-6'"
  [visible]="indicatorsToShowInOverview.length > 0">
  <ng-template pTemplate="header">
    <app-header icon="fas fa-circle-info" text="Übersicht"></app-header>
  </ng-template>
  <app-indicator-import-list
    *ngIf="indicatorsToShowInOverview.length > 0"
    [icon]="icon"
    [items]="indicatorsToShowInOverview"></app-indicator-import-list>
</p-sidebar>
<app-mask
  [visible]="indicatorsToShowInOverview.length > 0"
  (click)="closeOverview()"></app-mask>

<p-sidebar
  (onHide)="closeExportSelection()"
  position="right"
  [modal]="false"
  [styleClass]="'w-11'"
  [visible]="activeExportSelection">
  <ng-template pTemplate="header">
    <app-header
      icon="fas fa-list-check"
      text="Indikatoren auswählen und exportieren"
      sub="Sie wählen Indikatoren aus, die Sie exportieren wollen."></app-header>
  </ng-template>
  @if (activeExportSelection) {
    <app-indicator-pick-list
      action="export"
      targetHeaderSubtitle="Diese Indikatoren werden exportiert."></app-indicator-pick-list>
    <p-divider />
    <div class="flex align-items-center gap-3">
      <p-button
        [text]="true"
        [rounded]="true"
        severity="secondary"
        icon="fas fa-times-circle"
        (onClick)="closeExportSelection()"
        label="abbrechen"></p-button>
      <p-button
        class="ml-auto"
        [rounded]="true"
        [disabled]="indicatorStore.selection().length === 0"
        icon="fas fa-file-excel"
        (onClick)="export()"
        label="Indikatoren exportieren"></p-button>
    </div>
  }
</p-sidebar>
<app-mask
  [visible]="activeExportSelection"
  (click)="closeExportSelection()"></app-mask>
